;(function ($) {
  $(function () {
    if (!$('.page-template-template-carrier').length) {
      return
    }

    const buttonText = localize.translations.talentlyft.button
    const quantity = localize.translations.talentlyft.quantity
    const htmlToAppend = `<span class='talentlyft--button'>${buttonText}</span>`
    const countedPositionsWrapper = $('.js-counted-positions')
    const showMoreButton = $('.js-load-more-talentlyft-card')
    const cardsToShow = 6

    $.waitForElement('.tl-address', 5000).then(function () {
      $('.tl-title').prepend(htmlToAppend)
      $('.tl-title-text').matchHeight({
        byRow: true,
        property: 'height',
        target: null,
        remove: false
      })

      countTalentlyftCards()
      loadMoreTalentlyftCard(cardsToShow)
    })

    function loadMoreTalentlyftCard (showedCards) {
      var card = $('.tl-job')

      if (card.length < showedCards) {
        showMoreButton.hide()
        return
      }

      const remainedCards = card.length - showedCards
      const remainedCardsItem = $('.js-remained-cards')
      const remainedCardsText = `(${remainedCards} ${quantity})`

      remainedCardsItem.text(remainedCardsText)

      card.show().slice(showedCards).hide()

      showMoreButton.on('click', function () {
        card.show()
        showMoreButton.hide()
      })
    }

    function countTalentlyftCards () {
      var countedItems = $('.tl-job').length

      if (countedItems <= cardsToShow) {
        showMoreButton.hide()
      }

      if (countedItems <= 0) {
        countedPositionsWrapper.text(countedItems)
        $('#talentlyftWidget').hide()
        $('.js-no-carrier-result').removeClass('hidden')
      } else {
        countedPositionsWrapper.text(countedItems + ' ' + quantity)
      }
    }
  })
})(jQuery)
